import * as React from 'react';
import useSize from './hooks/useSize';
const SizeContext = React.createContext(undefined);
export const SizeContextProvider = ({ children, size }) => {
    const mergedSize = useSize(size);
    return React.createElement(SizeContext.Provider, { value: mergedSize }, children);
};
export default SizeContext;
